var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 111,
    viewBox: "0 0 150 111",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M71 4C71 0 67 0 67 0C67 0 63 0 63 4C63 8 67 8 67 8C67 8 71 8 71 4Z",
    fill: "#B93131"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M94 8C94 4 90 4 90 4C90 4 86 4 86 8C86 12 90 12 90 12C90 12 94 12 94 8Z",
    fill: "#27427A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M85.5 14.5C83.5 14 76 10 76 10C76 10 77.5 15 78 17.5C78.5 20 79.5 29 79.5 29C79.5 29 87 23 89 21.5C91 20 100 15 100 15C100 15 87.5 15 85.5 14.5Z",
    fill: "#27427A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M69 11C72.5 9.5 79 5 79 5C79 5 77 11 76.5 13C76 15 75.5 28.5 75.5 28.5C75.5 28.5 67.5 19.5 65 17.5C62.5 15.5 57 13 57 13C57 13 65.5 12.5 69 11Z",
    fill: "#B93131"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M69 31V68L80 73V24.5L69 31Z",
    fill: "#27427A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M87 73V75L96 80V35L90 37.6667V73H87Z",
    fill: "#27427A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M90 73V37.6667L87 39V73H90Z",
    fill: "#27427A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M103 81.75V83L113 87V46L106 48.1V82.5L103 81.75Z",
    fill: "#27427A"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M106 82.5V48.1L103 49V81.75L106 82.5Z",
    fill: "#27427A"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M113 46V87L122 88V49L113 46Z",
    fill: "#3576BB"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M96 35V80L103 81.75V49L106 48.1V40L96 35Z",
    fill: "#3576BB"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M80 24.5V73H87V39L90 37.6667V29.5L80 24.5Z",
    fill: "#3576BB"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M37 71.0002C6.5 71.5002 0 99.0002 0 99.0002C0 99.0002 8.5 79.5003 35.5 84.0002C62.5 88.5 87 112.5 115 110C143 107.5 149.5 82.0002 149.5 82.0002C149.5 82.0002 145.5 97.5 120.5 97.0002C95.5 96.5003 67.5 70.5002 37 71.0002Z",
    fill: "#B93131"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M52 62.5006C40.4996 60.5009 25 65.0005 25 65.0005C25 65.0005 43 63.0001 62 70.5C81 77.9999 104.5 92.0001 122 93C139.5 93.9999 146 78.5005 146 78.5005C146 78.5005 142.5 86.0003 125.5 87.0005C115.663 87.5793 101.942 78.3396 84 71.0003C70.9366 65.6566 56.8454 63.3431 52 62.5006Z",
    fill: "#27427A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTube);
export default __webpack_public_path__ + "static/media/tube.76260392783846c5dc58bba40d3ac49b.svg";
export { ForwardRef as ReactComponent };